<template>
  <div class="container">
    <div class="row">
      <div class="col-auto my-5">
        <h1>Výpočet kalkulace - nová verze</h1>
      </div>
    </div>
    <div class="card myTopMargin">
      <div class="card-header">
        <div class="row my-2">
          <h3>Základní informace</h3>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-2 form-group">
            <label for="version" class="form-label">Číslo verze</label>
            <input class="form-control" type="number" id="version" name="version" value=1 v-model="version" disabled>
          </div>
          <div class="col-4 form-group">
            <label for="version_tag" class="form-label">Tag verze</label>
            <input class="form-control" type="text" id="version_tag" name="version_tag" value="001_202500001"
                   v-model="versionTag" disabled>
          </div>
        </div>
        <div class="row my-3">
          <div class="col-6 form-group">
            <label for="description" class="form-label">Popis verze</label>
            <input
                :class="['form-control', versionDescription === null || versionDescription === '' ? 'is-invalid' : 'is-valid']"
                type="text" id="description" name="description" v-model="versionDescription">
          </div>
        </div>
        <div class="row my-3">
          <div class="col-2 form-group">
            <label for="vat" class="form-label">DPH:</label>
            <select v-model="settings.vat" class="form-select" id="vat" name="vat" disabled>
              <option value="-1" disabled selected>vyber DPH...</option>
              <option v-for="(text, key) in vat" :key="key" :value="key">
                {{ text }}
              </option>
            </select>
          </div>
          <div class="col-2 form-group">
            <label for="sale" class="form-label">Přirážka / sleva (%):</label>
            <input class="form-control" type="number" id="sale" name="sale" min="-100" value="0" v-model="sale"
                   v-tooltip="'Kalkulace, respektive ceny jednotlivých dílců, které budou přepočítány tímto koeficientem. (-) hodnota znamená slevu, (+) hodnota znamená přirážku. Hodnota je zobrazena jak v přehledu jednotlivých dílců tak, v rekapitulaci kalkulace. Cena dopravy, montáže a dořezů jsou ponechány beze změny.'"
                   data-tooltip-position="top"
                   data-tooltip-trigger="focus"/>
          </div>
          <div class="col-2 form-group">
            <label for="custom-cutoff-sale" class="form-label">Sleva prořezu materiálu (Kč): </label>
            <input
                :class="['form-control', customCutoffSale === '' || customCutoffSale < 0 ? 'is-invalid' : 'is-valid']"
                type="number" id="custom-cutoff-sale" name="custom-cutoff-sale" min="0" value="0"
                v-model="customCutoffSale"
                v-tooltip="'Sleva na prořez materiálu se odečte v absolutní hodnotě. Po zadání slevy se automaticky zakáže nabídka další možné slevy na prořez materiálu.'"
                data-tooltip-position="top"
                data-tooltip-trigger="focus"/>
          </div>
          <div class="col-2 form-group">
            <label for="commission" class="form-label">Provize (%): </label>
            <input
                :class="['form-control', commissionRate < 0 || commissionRate > 100 ? 'is-invalid' : 'is-valid']"
                type="number" id="commission" name="commission" min="0" max="100" step="1" value="0"
                v-model="commissionRate"
                v-tooltip="'Provize pro obchodníka v %. Vypočítává se z ceny výroby - tj. navýší se cena jednotlivých dílců. Doprava, montáž, zaměření a dořezy zůstávají beze změny. Cena není zobrazena v PDF kalkulace.'"
                data-tooltip-position="top"
                data-tooltip-trigger="focus"/>
          </div>
        </div>

        <!--        <div class="form-group my-3">-->
        <!--          <div class="form-check form-switch">-->
        <!--            <label class="form-check-label" for="cutoff">Nezapočítat dořez</label>-->
        <!--            <input class="form-check-input" type="checkbox" role="switch" id="cutoff"-->
        <!--                   name="cutoff" v-model="cutoffMaterialInclude">-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="form-group my-3">
          <div class="form-check form-switch">
            <label class="form-check-label" for="rate_switch">Přepočítat cenu materiálu dle cenových skupin</label>
            <input class="form-check-input" type="checkbox" role="switch" id="rate_switch"
                   name="cutoff" @change="priceCalculationSwitch = $event.target.checked ? 1 : 0" checked>
          </div>
        </div>
        <div class="form-group my-3">
          <div class="form-check form-switch">
            <label class="form-check-label" for="cutoff-sale-switch">Nenabízej slevy na zbytkový materiál</label>
            <input class="form-check-input" type="checkbox" role="switch" id="cutoff-sale-switch"
                   name="cutoff-sale-switch" v-model="cutoffSaleSwitch" :disabled="cutoffSaleSwitchDisable">
          </div>
        </div>
      </div>
      <div class="form-group my-3">
        <CalculationMaterialSizeSetter :cid="cid" @material-dimensions="(data) => {dimensions = data}"/>
      </div>
      <div class="card-footer">
        <div class="row justify-content-end">
          <div class="col-auto">
            <a class="btn btn-danger mx-1" @click="doCancel">Zrušit</a>
            <a class="btn btn-success mx-1" @click="doCalculate" :class="calculateBtnDisable">Vypočítej</a>
            <a v-role="'developer'" class="btn btn-success mx-1" @click="doSimulateCalculation"
               :class="calculateBtnDisable">Spočítej nákladovou cenu</a>
          </div>
        </div>
      </div>
    </div>
    <CalculationCalculateTable v-if="isCalculated"
                               :calculated-data="calculatedData"
                               :calculation="calculation"
                               @cancel="isCalculated = false"/>
  </div>
</template>

<script setup>
import {ref, reactive, onMounted, defineProps, computed, watch} from 'vue'
import {useStore} from 'vuex'
import CalculationCalculateTable from "@/components/calculation/CalculationCalculateTable.vue"
import CalculationMaterialSizeSetter from "@/components/calculation/CalculationMaterialSizeSetter.vue"
import router from "@/router";
import myApi from "@/api/api";

const props = defineProps(['cid'])
const store = useStore()

const calculation = ref(null)
const vat = reactive({
  0: '0 %',
  12: '12 %',
  21: '21 %',
})
const version = ref(null)
const versionTag = ref(null)
const versionDescription = ref(null)
const calculatedData = ref(null)
const isCalculated = ref(false)
const dimensions = ref({})
const sale = ref(0)
const priceCalculationSwitch = ref(1)
const customCutoffSale = ref(0)
const cutoffSaleSwitch = ref(false)
const basePriceSwitch = ref(false)
const commissionRate = ref(0)

const settings = computed(() => ({
  'cid': props.cid,
  'version': version.value,
  'version_tag': versionTag.value,
  'description': versionDescription.value,
  'vat': calculation?.value ? calculation.value.vat : 0,
  'dimensions': JSON.stringify(dimensions.value),
  'sale': sale.value,
  'price_switch': priceCalculationSwitch.value,
  'custom_cutoff_sale': customCutoffSale.value,
  'cutoff_sale_switch': !cutoffSaleSwitch.value,
  'base_price_switch': basePriceSwitch.value,
  'commission_rate': commissionRate.value,
}))

// Computed property pro calculateBtnDisable
const calculateBtnDisable = computed(() => {
  if (versionDescription.value === null || versionDescription.value === '' || customCutoffSale.value < 0 || customCutoffSale.value === '') {
    return 'disabled'
  }
  return ''
})

const cutoffSaleSwitchDisable = computed(() => {
  if (customCutoffSale.value > 0) {
    return true
  }
  return false
})

// Přidejte watcher pro automatické nastavení
watch(customCutoffSale, (newValue) => {
  if (newValue > 0) {
    cutoffSaleSwitch.value = true
  }
  if (newValue === 0) {
    cutoffSaleSwitch.value = false
  }
})

const doSimulateCalculation = async () => {
  isCalculated.value = false;
  basePriceSwitch.value = true;
  calculatedData.value = await myApi.calculationCalculate(
      settings.value
  )
  isCalculated.value = true;
  return true
}

const doCalculate = async () => {
  isCalculated.value = false;
  basePriceSwitch.value = false;
  calculatedData.value = await myApi.calculationCalculate(
      settings.value
  )
  isCalculated.value = true;
}

const doCancel = () => {
  router.go(-1)
}

onMounted(async () => {
  store.dispatch('calculation/setCalculationById', props.cid).then(() => {
    calculation.value = store.getters['calculation/getCalculation']
  })
  const version_query = await myApi.getCalculationNewVersion(props.cid)
  version.value = version_query.version
  versionTag.value = version_query.version_tag
})

</script>

<style scoped>
</style>

